import { render, staticRenderFns } from "./profile-info.vue?vue&type=template&id=13c467f2"
import script from "./profile-info.vue?vue&type=script&lang=js"
export * from "./profile-info.vue?vue&type=script&lang=js"
import style0 from "./profile-info.vue?vue&type=style&index=0&id=13c467f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports